import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import DropLetter from "components/layout/dropLetter/DropLetter";
import React from "react";
import config from "config";
import HymnTable from "./table/HymnTable";

function PbhSearchPage() {
  const content = config.features.pbhSearch ? (
    <div>
      <Typography variant="body2" lineHeight={1.8}>
        <DropLetter letter="P" />
        eruse the contents of the PBH and listen to previews of each hymn using
        the table below.
      </Typography>
      <Typography variant="body2" color="#666">
        <ul>
          <li>
            Sort alphabetically in any column by clicking the column header
          </li>
          <li>Click the plus sign to view song details</li>
          <li>Click the play symbol to hear a midi recording of the song</li>
          <li>
            Use the search field to find a particular song, lyricist, tune,
            meter, etc.
          </li>
          <li>
            The search includes ALL song details, including those that are
            hidden. For example, searching ‘Isaac Watts’ will return multiple
            entries. View the details of the songs returned to see that they
            were all written by Isaac Watts.
          </li>
        </ul>
      </Typography>
      <HymnTable />
    </div>
  ) : (
    <Typography variant="h4">Coming Soon</Typography>
  );
  return (
    <PageLayout>
      <DefaultCard title="SEARCH">{content}</DefaultCard>
    </PageLayout>
  );
}

export default PbhSearchPage;
